// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__3UUha","text":"style_text__13eGX","poweredImg":"style_poweredImg__2Doz0"};